// Prevent Zone.js from patching MutationObserver.
//
// Zone.js wraps browser APIs (including MutationObserver) so Angular can detect
// when async operations complete. However, this patching breaks Mixpanel's rrweb
// session recording in Safari: rrweb tries to escape the Zone patch via a hidden
// iframe's MutationObserver, but Safari's security model causes that iframe
// observer to silently drop callbacks, so DOM changes are never recorded.
//
// Setting this flag before zone.js loads tells Zone.js to skip patching
// MutationObserver entirely. Angular's change detection does not rely on
// MutationObserver (it hooks setTimeout/Promise/XHR/addEventListener instead),
// so this is safe and has no impact on Angular's CD behavior.
//
// Reference: https://github.com/angular/angular/issues/31712
(window as any).__Zone_disable_MutationObserver = true;
